// REACT
import React, {Component} from 'react';

// REDUX
import {connect} from 'react-redux';
import * as actions from '../actions';

// COMPONENTS
import { Content } from '../components/Content';
import { JoinCallMask } from '../components/VideoUI/JoinCallMask';

// UTILS
import { constants } from '../constants/index';
const moment = require('moment-timezone');

class ConsultCountdown extends Component {
    constructor(props){
        super(props);
        
        this.state = {
            days: '00',
            hours: '00',
            milliseconds: '00',
            minutes: '00',
            seconds: '00',
            timer: null,
        };
    }
    
    componentDidMount(){
        document.getElementById('top').scrollIntoView();
        // this.getCountdown();
    }
    
    lessThanTen = (num) => {
        if (num < 10) {
            const numString = '0' + num;
            return numString;
        }
        return num;
    }
    lessThanAHundred = (num) => {
        if (num < 100 && num > 9) {
            const numString = '0' + num;
            return numString;
        }
        if (num < 10) {
            const numString = '00' + num;
            return numString;
        }
        return num;
    }

    getNow = () => {
        return moment(new Date()).format('x');
    }
    getCountdown = () => {
        const countdownTimer = setInterval(()=>{
            // console.log(this.props.match.params.id);
            const consultTimestamp = parseInt(this.props.match.params.id, 10);
            const now = this.getNow();
            // console.log(now, consultTimestamp);
            const duration = (consultTimestamp - now); 
            // console.log('Duration', duration);
            
            const days = Math.floor(moment.duration(duration).asDays());
            const daysTimestamp = days * 86400000;
            const durationMinusDays = duration - daysTimestamp;
            
            const hours = Math.floor(moment.duration(durationMinusDays).asHours()); // number of hours left over
            // console.log('HOURS:', hours);
            const hoursTimestamp = hours * 3600000; 
            const durationMinusHours = durationMinusDays - hoursTimestamp;
            
            const minutes = Math.floor(moment.duration(durationMinusHours).asMinutes()); // number of minutes left over

            // console.log(minutes, 'minutes', durationMinusHours);
            const minutesTimestamp = minutes * 60000;
            const durationMinusMinutes = durationMinusHours - minutesTimestamp;
            
            const seconds = Math.floor(moment.duration(durationMinusMinutes).asSeconds()); // number of seconds left over
            const secondsTimestamp = seconds * 1000;
            const durationMinusSeconds = durationMinusMinutes - secondsTimestamp;
            
            const milliseconds = Math.floor(moment.duration(durationMinusSeconds).asMilliseconds()); // number of milliseconds left over
        
        
            this.setState({
                days: this.lessThanTen(days),
                hours: this.lessThanTen(hours),
                minutes: this.lessThanTen(minutes),
                seconds: this.lessThanTen(seconds),
                milliseconds: this.lessThanAHundred(milliseconds)
            });
        }, 1);

        this.setState({
            timer: countdownTimer
        });
    }

    componentWillUnmount() {
        clearInterval(this.state.timer);
    }

    render() {
        return (
            <div style={constants.layout.container}>
                {/* <Toolbar /> */}
                <JoinCallMask style={{ minWidth: '100%', maxWidth: '100vw', width: '100vw' }}>
                    <div style={{ minWidth: '100%', display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }}>
                        {/* <ul style={{ width: '800px', fontWeight: 700, position: 'relative', zIndex: 999, display: 'flex', justifyContent: 'space-between' }}>
                            <li>DAYS</li>
                            <li>HRS</li>
                            <li>MIN</li>
                            <li>SEC</li>
                            <li>MILLI</li>
                        </ul>
                        <span style={{ fontWeight: 700, zIndex: 999, position: 'relative', fontFamily: 'Open Sans, sans-serif', fontSize: '100%', color: 'white' }}>
                            {this.state.days}:{this.state.hours}:{this.state.minutes}:{this.state.seconds}:{this.state.milliseconds}
                        </span> */}
                    
                    
                        {/* <span style={{ fontWeight: 300, zIndex: 999, marginBottom: 20, position: 'relative', fontFamily: 'Open Sans, sans-serif', fontSize: 20, color: 'rgb(200,200,200)' }}>
                            ...until your consult.
                        </span> */}
                        <Content 
                            style={{ textAlign: 'center', display: 'flex', justifyContent: 'center', zIndex: 999, position: 'relative', color: 'white', margin: '0 auto', maxWidth: '100vw'}}
                            mainTitleText="Your video consult is fast approaching... but&nbsp;it's&nbsp;not&nbsp;today." 
                        />
                        <span style={{ paddingTop: 20, textAlign: 'center', fontWeight: 400, zIndex: 999, position: 'relative', fontFamily: 'Open Sans, sans-serif', fontSize: 25, color: 'rgb(180,180,180)', margin: '0 auto', maxWidth: '60%'  }}>
                            Check back in on {moment(this.props.match.params.id, 'x').format('MMMM DD, YYYY')}
                        </span>
                        <p style={{ paddingTop: 60, textAlign: 'center', fontWeight: 200, zIndex: 999, position: 'relative', fontFamily: 'Open Sans, sans-serif', fontSize: 15, color: 'rgb(210,210,210)', margin: '0 auto', width: '50vw' }}> 
                            <span style={{ color: 'white', fontWeight: 700 }}>Note:</span> <br/> You can either reuse the email link we sent or use the 'Start Consult' button in the booking tab for your purchased service. 
                        </p>
                    </div>

                    <div className="maskTint"></div>
                    <div className="maskImage"></div>
                </JoinCallMask>
              
                    
                    
            </div>
        );
    }
}

const mapStateToProps = ({ auth, video }) => {
    // console.log(auth, 'is auth');
    return {
        codeIsVerified: video.isVerified,
        userId: (auth.authData) ? auth.authData.id : null
    };
}


export default connect(mapStateToProps, actions)(ConsultCountdown);



// WEBPACK FOOTER //
// ./src/js/containers/ConsultCountdown.jsx